import { observer } from "mobx-react";
import * as React from "react";
import { StaticTextNodeStore } from "../../../stores";
import { TopBar } from "../TopBar";
import { ResizableNodeView } from "../ResizableNodeView";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./../NodeView.scss";
import "./TextNodeView.scss";

interface TextNodeProps {
    store: StaticTextNodeStore;
}

/**
 * This class represents the view for a text node.
 * It extends ResizableNodeView to support interactive resizing
 * while displaying text content sourced from the node store.
 */
@observer
export class TextNodeView extends ResizableNodeView<StaticTextNodeStore> {

    /**
     * This getter method returns the CSS class name for the text node.
     * @returns Class name for the text node container.
     */
    protected getNodeClassName(): string {
        return "textNode";
    }

    /**
     * This method renders the visual content of the text node, 
     * including the top bar.
     * @returns Node representing the text node content
     */
    protected renderContent(): React.ReactNode {
        const store = this.props.store;

        return (
            <>
                <TopBar store={store} />

                <div
                    className="scroll-box"
                    onPointerDownCapture={(e) => e.stopPropagation()}
                >
                    <div className="content">
                        <h3 className="title">{store.title}</h3>

                        <ReactQuill
                            value={store.text}
                            onChange={(value) => (store.text = value)}
                        />
                    </div>
                </div>
            </>
        );
    }
}